import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimWorkOrderObjectSelectionDataFilterInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderObjectSelectionListGql } from '../../bimWorkOrderQueries';

const requestId = 'bimWorkOrderObjectSelectionList';

export const useBimWorkOrderObjectSelectionList = () => {
    const dispatch = useDispatch();

    const [
        bimWorkOrderObjectSelectionListData,
        bimWorkOrderObjectSelectionListStatus,
        bimWorkOrderObjectSelectionListError,
        bimWorkOrderObjectSelectionListRequest,
    ] = useRequest({
        requestId,
        query: bimWorkOrderObjectSelectionListGql,
        withEffect: false,
    });

    const [bimWorkOrderObjectSelectionListReset] = useResetStoreData({ requestId });

    const bimWorkOrderObjectSelectionListMakeRequest = useCallback(
        (wOrderId: number, constructionTypeId?: number) => {
            if (!constructionTypeId) {
                return;
            }

            const where: BimWorkOrderObjectSelectionDataFilterInput = {
                constructionType: { id: { eq: constructionTypeId } },
            };

            bimWorkOrderObjectSelectionListReset(undefined);
            dispatch(bimWorkOrderObjectSelectionListRequest({ workOrderId: wOrderId, where }));
        },
        [bimWorkOrderObjectSelectionListRequest, bimWorkOrderObjectSelectionListReset, dispatch],
    );

    return {
        bimWorkOrderObjectSelectionListReset,
        bimWorkOrderObjectSelectionListData,
        bimWorkOrderObjectSelectionListStatus,
        bimWorkOrderObjectSelectionListError,
        bimWorkOrderObjectSelectionListRequest,
        bimWorkOrderObjectSelectionListMakeRequest,
    };
};
